export default __webpack_public_path__ + "static/media/_dkg_haut_rgb.980e018d.svg";